module.exports = __webpack_public_path__ + "media/packs/images/flags/AE-105501bbb811e2a320b253c78c275f70.svg";